import React from 'react';
import ActionBarStrip from '../../_partials/ActionBarStrip';
import FavouriteButton from '../../buttons/FavouriteButtonWithPopover';
import CommentButton from '../../buttons/CommentButton';
import AddToGroupButton from '../../buttons/AddToGroupButton/AddToGroupButtonWithPopover';
import MoreButton from '../../buttons/MoreButton';
import DeleteButton from '../../buttons/DeleteButton';
import EditButton from '../../buttons/EditButton';
import AwardBadgeButton from '../../buttons/AwardBadgeButton';
import AdoptableSeller from '../../buttons/AdoptableSeller';
import AddToPrivateCollectionButtonWithPopover from '../../buttons/AddToPrivateCollectionButtonWithPopover';
import AdoptableBuyer from '../../buttons/AdoptableBuyer';
import OrderCommissionButton from '../../buttons/OrderCommissionButton';
import FreeDownloadButton from '../../buttons/DownloadButton/FreeDownloadButton';
import LoginToDownloadButton from '../../buttons/DownloadButton/LoginToDownloadButton';
import SellYourArtLink from '../../buttons/SellYourArtLink';
import CommissionStatusButton from '../../buttons/CommissionStatusButton';
import { ElementVisibility, useElementVisibilityForArea } from '../../ElementVisibilityContext';
import s from './MobileActionBar.scss';
export const MobileActionBar = ({ deviation, isOwner })=>{
    const primaryBarElementVisibility = useElementVisibilityForArea(ElementVisibility.PrimaryBar);
    const secondaryBarElementVisibility = useElementVisibilityForArea(ElementVisibility.SecondaryBar);
    return /*#__PURE__*/ React.createElement(ActionBarStrip, {
        className: s['root']
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['icons-wrapper']
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['left-block']
    }, primaryBarElementVisibility.favourite && /*#__PURE__*/ React.createElement("span", {
        className: s['icon']
    }, /*#__PURE__*/ React.createElement(FavouriteButton, {
        deviation: deviation,
        actionBarType: "primary"
    })), primaryBarElementVisibility.comment && /*#__PURE__*/ React.createElement("span", {
        className: s['icon']
    }, /*#__PURE__*/ React.createElement(CommentButton, {
        deviation: deviation,
        isOwner: isOwner
    })), primaryBarElementVisibility.addToGroup && !primaryBarElementVisibility.meta.hasPrimaryMoreActionsMenu && /*#__PURE__*/ React.createElement("span", {
        className: s['icon']
    }, /*#__PURE__*/ React.createElement(AddToGroupButton, {
        deviation: deviation
    }))), /*#__PURE__*/ React.createElement("div", {
        className: s['right-block']
    }, primaryBarElementVisibility.orderCommission && /*#__PURE__*/ React.createElement("span", {
        className: s['icon']
    }, /*#__PURE__*/ React.createElement(OrderCommissionButton, {
        deviation: deviation
    })), primaryBarElementVisibility.privateCollection && /*#__PURE__*/ React.createElement("span", {
        className: s['icon']
    }, /*#__PURE__*/ React.createElement(AddToPrivateCollectionButtonWithPopover, {
        deviation: deviation
    })), // The "add to group" button can be in two different spots on the primary bar depending on
    // if the more menu is present.
    //
    // NOTE: We shouldn't use this method to swap controls between bars or the more menu. That's what
    // our elementVisibilityMap is for. However, this is fine to check against if we're only moving it around
    // within the domain of the indicated area. (e.g. if elementVisibilityMap has a control appearing in
    // `ElementVisibility.PrimaryBar`, it's fine to move the control around inside the primary bar, but it's not fine
    // to have it jump to the secondary bar. Alter the rules inside elementVisibility map instead if you need that behaviour)
    primaryBarElementVisibility.addToGroup && primaryBarElementVisibility.meta.hasPrimaryMoreActionsMenu && /*#__PURE__*/ React.createElement("span", {
        className: s['icon']
    }, /*#__PURE__*/ React.createElement(AddToGroupButton, {
        deviation: deviation
    })), primaryBarElementVisibility.awardBadge && /*#__PURE__*/ React.createElement("span", {
        className: s['icon']
    }, /*#__PURE__*/ React.createElement(AwardBadgeButton, {
        deviation: deviation
    })), primaryBarElementVisibility.freeDownload && /*#__PURE__*/ React.createElement("span", {
        className: s['icon']
    }, /*#__PURE__*/ React.createElement(FreeDownloadButton, {
        deviation: deviation
    })), primaryBarElementVisibility.meta.hasPrimaryMoreActionsMenu && /*#__PURE__*/ React.createElement("span", {
        className: s['icon']
    }, /*#__PURE__*/ React.createElement(MoreButton, {
        deviation: deviation
    })), primaryBarElementVisibility.deleteDeviation && /*#__PURE__*/ React.createElement("span", {
        className: s['icon']
    }, /*#__PURE__*/ React.createElement(DeleteButton, {
        deviation: deviation
    })), primaryBarElementVisibility.editDeviation && /*#__PURE__*/ React.createElement("span", {
        className: s['icon']
    }, /*#__PURE__*/ React.createElement(EditButton, {
        deviation: deviation
    })), primaryBarElementVisibility.commissionStatus && /*#__PURE__*/ React.createElement("span", {
        className: s['icon']
    }, /*#__PURE__*/ React.createElement(CommissionStatusButton, {
        deviation: deviation
    })))), /*#__PURE__*/ React.createElement("div", {
        className: s['download-button-row']
    }, secondaryBarElementVisibility.sellDeviation && /*#__PURE__*/ React.createElement(SellYourArtLink, {
        deviation: deviation
    }), secondaryBarElementVisibility.freeDownload && /*#__PURE__*/ React.createElement(LoginToDownloadButton, {
        className: s['full-width'],
        deviation: deviation
    }), secondaryBarElementVisibility.elementGroups.adoptableSeller.groupVisibility && /*#__PURE__*/ React.createElement(AdoptableSeller, {
        deviation: deviation
    }), secondaryBarElementVisibility.elementGroups.adoptableBuyer.groupVisibility && /*#__PURE__*/ React.createElement(AdoptableBuyer, {
        deviation: deviation
    })));
};
MobileActionBar.displayName = 'MobileActionBar';
export default MobileActionBar;

//# sourceMappingURL=MobileActionBar.js.map